<template>
    <div class="row">
        <div class="col-12">
            <TitleComponent title="Confirmación de la compra"></TitleComponent>
        </div>
        <div class="col-12">
            <div class="row">
                <div v-for="(entrada, index) in datos_compra.datos_compradores" :key="index" class="col-12 bg-light mb-3">
                    <h2>
                        <strong>
                            <span class="text-primary">ENTRADA {{ ++index }}: </span>
                            <span> 
                                <template v-if="entrada.numero">
                                    {{ 'PLAZA: ' + entrada.numero }}
                                </template>
                                <template v-else-if="entrada.asiento">
                                    <span> {{ entrada.asiento.zona_nombre }}</span>
                                    <span v-if="entrada.asiento.row"> / FILA: {{ entrada.asiento.row }}</span>
                                    <span v-if="entrada.asiento.asiento">/ BUTACA: {{ entrada.asiento.asiento }}</span>
                                </template>
                                <template v-else-if="entrada.butaca">
                                    <span v-if="entrada.nombre_sector">SECTOR: {{ entrada.nombre_sector + ' / ' }}</span>
                                    <span>FILA: {{ entrada.fila }} </span>                                     
                                    <span>/ BUTACA: {{ entrada.butaca }}</span>                              
                                </template>
                                - PRECIO: 
                                <span :style="entrada.descuento > 0 ? 'text-decoration:line-through' : ''">{{ (datos_compra.metodo_pago.id == 6 || datos_compra.metodo_pago.id == 10 ? 0 : getPrecioEntrada(entrada.precio)) | formatear_precio }}</span>
                                <span v-if="entrada.descuento > 0" class="text-primary"> ({{ datos_compra.metodo_pago.id == 6 || datos_compra.metodo_pago.id == 10 ? 0 : calcularDescuento(getPrecioEntrada(entrada.precio), entrada.descuento) | formatear_precio }} / - {{ entrada.descuento }}%)</span>
                            </span>
                        </strong>
                    </h2>
                </div>
            </div>
        </div>

        <div class="col-12">
            <h2>
                <strong>
                    TOTAL: 
                    <span class="display-4" :style="total_descuento != total ? 'text-decoration:line-through' : ''">{{ datos_compra.metodo_pago.id == 6 || datos_compra.metodo_pago.id == 10 ? 0 : total | formatear_precio }} </span>
                    <span v-if="total_descuento!= total" class="display-4 text-primary">({{ datos_compra.metodo_pago.id == 6 || datos_compra.metodo_pago.id == 10 ? 0 : total_descuento | formatear_precio }})</span>
                </strong></h2>
        </div>
        <div class="col-12">
            <h2><strong>FORMA DE PAGO: <span class="display-4">{{ datos_compra.metodo_pago.nombre }}</span></strong></h2>
        </div>      
        <div class="col-12" v-if="!compra_finalizada">
            <Button @click="procesarCompra" :disabled="loading || error">
                <span v-if="datos_compra.metodo_pago.id == 6 || datos_compra.metodo_pago.id == 10">
                    <span v-if="email || whatsapp">Enviar invitaciones</span>
                    <span v-else>Imprimir invitaciones</span>
                </span>
                <span v-else>
                    Finalizar compra
                </span>
            </Button>
            <div class="col-12" v-if="loading" style="height: 120px">
                <LoaderComponent></LoaderComponent>
            </div>
        </div>
        <div class="col-12" v-else>
            <template v-if="!loading">
                <div>
                    <template v-if="qr_codes.length > 0">
                        <Button 
                            type="button" 
                            ref="imprimirEntradas"
                            :href="imprimir_url | formatear_url({ '%EVENTO_ID%' : $route.params.evento_id, '%SESION_ID%' : $route.params.sesion_id, 'qr_codes' : qr_codes })" 
                            target="_blank"
                        >
                            IMPRIMIR ENTRADAS
                        </Button>
                        <Button 
                            type="button" 
                            ref="descargarEntradas"
                            :href="api_base + '/f/partidos/entradas/pdf?qr_codes=' + [qr_codes] + '&event_id=' + $route.params.evento_id"
                            target="_blank"
                            class="ml-2"
                        >
                            DESCARGAR ENTRADAS EN PDF
                        </Button>
                    </template>
    
                    <Button type="button" class="ml-2" v-if="whatsapp_url" ref="enviarWhatsapp" :href="whatsapp_url" target="_blank">ENVIAR ENTRADAS POR WHATSAPP</Button>
                </div>
            </template>
            <div class="col-12" v-else style="height: 120px">
                <LoaderComponent></LoaderComponent>
            </div>
        </div>
        <div class="col-12 mt-3" v-if="compra_finalizada && !loading">
            <div class="alert alert-success alert-dismissible">
                <h5><i class="icon fas fa-check"></i> ¡Compra finalizada correctamente!</h5>
                <template v-if="recinto">
                    <Button @click="goTo(1)">Volver a selección de zona</Button>
                    <Button v-if="mode === 1" class="ml-3" @click="goTo(2, datos_compra.zona_id)">Continuar en esta zona</Button>
                </template>
                <template v-else>
                    <Button @click="goTo(2)">Otra venta</Button>
                </template>
            </div>
        </div>
        <div class="col-12 mt-3" v-if="error">
            <div class="alert alert-danger alert-dismissible">
                <h5>{{ error }}</h5>
                <template v-if="recinto">
                    <Button @click="goTo(1)">Volver a selección de zona</Button>
                    <Button v-if="mode === 1" class="ml-3" @click="goTo(2, datos_compra.zona_id)">Continuar en esta zona</Button>
                </template>
            </div>
        </div>
    </div>
</template>

<script>
import TitleComponent from '@/components/backend/stepper/components/TitleComponent';

export default {
    props: ['datos_compra', 'email', 'whatsapp', 'carrito_id', 'recinto', 'mode', 'amigo_abonado_id'],
    data() {
        return {
            loading: false,
            compra_finalizada: false,
            qr_codes: null,
            mensaje_email: null,
            whatsapp_url: null,
            imprimir_url: null,
            api_base: process.env.VUE_APP_API_BASE,
            error: null
        }
    },
    created() {
        this.imprimir_url = this.config.IMPRIMIR_URL;
    },
    computed: {
        total() {
            var total = 0;
            if(this.datos_compra.datos_compradores != undefined) {
                for(var i in this.datos_compra.datos_compradores) {
                    total += this.getPrecioEntrada(this.datos_compra.datos_compradores[i].precio);
                }
            }

            return total;
        },
        total_descuento() {
            var total = 0;
            if(this.datos_compra.datos_compradores != undefined) {
                for(var i in this.datos_compra.datos_compradores) {
                    var total_entrada_2 = this.getPrecioEntrada(this.datos_compra.datos_compradores[i].precio);

                    total = total + this.calcularDescuento(total_entrada_2, this.datos_compra.datos_compradores[i].descuento);
                }
            }            

            return total;
        }
    },
    methods: {
        calcularDescuento(precio, descuento) {
            if (descuento === 0) {
                return precio;
            }

            var desc = (descuento / 100) * precio;
            return precio - desc;
        },
        goTo(paso, zona_id) {
            this.$emit('goTo', paso, zona_id);
        },
        procesarCompra() {
            this.loading = true;
            if (this.datos_compra.entradas) {
                this.datos_compra.entradas.forEach(entrada => {
                    entrada.price = entrada.precio;
                    entrada.price_management = entrada.price_management_taquilla;
                    entrada.price_management_interno = entrada.price_management_taquilla_interno;
                });
            }
            
            var params = Object.assign({}, this.datos_compra);
            params.metodo_pago = params.metodo_pago.id;
            params.carrito_id = this.carrito_id;
            params.amigo_abonado_id = this.amigo_abonado_id
            params.filters = {};
            params.sesion_id = this.$route.params.sesion_id;

            this.$store.dispatch(this.config.getVuexAlias('back.events.sesiones.compra.taquilla'), params).then(res => {
                this.compra_finalizada = true;
                this.qr_codes = res.data.qr_codes;

                this.mensaje_email = res.data.mensaje_email;

                this.whatsapp_url = res.data.whatsapp_url;
                
                setTimeout(() => {
                    this.loading = false;
                }, 3000);
            }).catch(e => {
                this.loading = false;
                this.error = e.response.data.message;
            });
        },
        getPrecioEntrada(precio) {
            let price = parseFloat(precio.precio);

            if(precio.price_management_interno_taquilla || precio.gd_interno) {
                return price;
            }

            return price + parseFloat(precio.price_management_taquilla);
        }
    },
    components: {
        TitleComponent
    }
}
</script>
